import { useTranslation } from "react-i18next";

export default function FinalCtaSection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A beautiful modern steel-frame luxury house at twilight with warm interior lights glowing through large windows, surrounded by a peaceful garden, deep blue evening sky with warm amber house glow, contemporary architecture with clean geometric lines, professional architectural twilight photography, cozy and inviting residential atmosphere, warm cream and champagne gold color tones, no text no logos no people"
          alt="夢想住宅夜景"
          className="w-full h-full object-cover object-center"
          width="1920"
          height="600"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/50 to-black/55" />
      </div>

      <div className="relative z-10 container-main px-4 md:px-8 lg:px-12 text-center">
        <span className="inline-block px-4 py-1.5 bg-champagne/20 backdrop-blur-sm text-champagne text-base md:text-base font-semibold tracking-wider rounded-full mb-5">
          {t("contact.final.label")}
        </span>
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-cream mb-4 max-w-3xl mx-auto">
          {t("contact.final.title")}
        </h2>
        <p className="text-base md:text-base text-cream/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          {t("contact.final.desc")}
        </p>
        <a
          href="https://lin.ee/OpssTIM"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-7 py-3.5 bg-champagne text-graphite rounded-full text-base font-semibold transition-all duration-300 hover:bg-champagne/90 hover:-translate-y-0.5 whitespace-nowrap"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-line-fill" />
          </span>
          {t("contact.final.cta")}
        </a>
      </div>
    </section>
  );
}